import { forwardRef } from 'react';
import { not } from 'ramda';
import { Box } from '@alf/uikit';
import { Icon } from '@namespace/icons2';
import {
  notificationCenterActions,
  useNotificationCenterStore
} from '../../store';

import styles from './index.module.css';

const { SET_IS_NOTIFICATIONS_LIST_OPENED } = notificationCenterActions;

export const BellNotificationIcon = forwardRef((_, ref) => {
  const hasNotifications = useNotificationCenterStore('hasNotifications');

  return (
    <Box
      ref={ref}
      onClick={() => SET_IS_NOTIFICATIONS_LIST_OPENED(not)}
      className={styles.root}
    >
      <Icon
        size="l"
        name="icons/general/state/notification-bell"
        color="header_txt_2"
      />
      {hasNotifications && (
        <Icon
          size="l"
          name="icons/index/counter-general"
          color="accent_color_3"
          className={styles.hasNotifications}
        />
      )}
    </Box>
  );
});
